import "./user-select-option.scss";

const UserSelectOption = ({
  inputLabel,
}: {
  inputLabel: string;
}) => <span className="user-select-option">{inputLabel}</span>;

export default UserSelectOption;
